import { useState } from "react";
import { Link } from "react-router-dom";
import AppName from "../AppName";
import Cart from "../Cart/Cart";
import Dropdown from "../UI/DropDown";

const DesktopNavbar = ({ mainLinks, homeCSS }) => {
  const [assetDropDown, setAssetDropdown] = useState(false);

  const dropDownToggleHandler = () => {
    setAssetDropdown((prev) => !prev);
  };

  const assetDropdownList = [
    { name: "Assets", url: "/assets" },
    { name: "Featured", url: "/assets-featured" },
    { name: "Facebook", url: "/assets/categories/facebook" },
    { name: "X (Twitter)", url: "/assets/categories/x" },
    { name: "Instagram", url: "/assets/categories/instagram" },
    { name: "TikTok", url: "/assets/categories/tiktok" },
  ].map((item) => (
    <Link
      key={item.name}
      to={item.url}
      className="block px-4 py-2 text-sm text-gray-300 hover:bg-white/5 hover:text-white transition"
      onClick={() => setAssetDropdown(false)}
    >
      {item.name}
    </Link>
  ));

  // Separate register/login from other links
  const centerLinks = mainLinks.filter((link) => link.name !== "Get Started");

  const registerLink = mainLinks.find((link) => link.name === "Get Started");

  return (
    <nav
      className={`hidden md:flex w-full backdrop-blur-md bg-gray-950 ${
        homeCSS ? homeCSS : "bg-gray-950 border-b border-white/10"
      }`}
    >
      <div className="max-w-7xl mx-auto w-full px-6 h-16 flex items-center justify-between">
        {/* LEFT - LOGO */}
        <div className="flex items-center">
          <AppName
            CSSStyles="text-2xl font-semibold tracking-tight"
            homeCSS={!!homeCSS}
          />
        </div>

        {/* CENTER - MAIN NAV */}
        <ul className="flex items-center space-x-8 text-base font-medium">
          <li>
            <Link to="/" className="text-gray-300 hover:text-white transition">
              Home
            </Link>
          </li>

          <Dropdown
            title="Mart"
            onToggle={dropDownToggleHandler}
            assetDropdown={assetDropDown}
          >
            {assetDropdownList}
          </Dropdown>

          {centerLinks.map((link) => (
            <li key={link.name}>
              <Link
                to={link.url}
                className="text-gray-300 hover:text-white transition"
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>

        {/* RIGHT - ACTIONS */}
        <div className="flex items-center space-x-6">
          {registerLink && (
            <Link
              to={registerLink.url}
              className="bg-white text-black text-sm font-medium px-4 py-2 rounded-md hover:bg-gray-200 transition"
            >
              {registerLink.name}
            </Link>
          )}
          <Cart />
        </div>
      </div>
    </nav>
  );
};

export default DesktopNavbar;
